import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class DocumentedInformation extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'documentedInformation'}
            title={'PROCEDURE P8.0 DOCUMENTED INFORMATION'}
            exportTitle={'<h2>Procedure P8.0 Documented Information</h2>'}
            exportFileName={'documented_information.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (DocumentedInformation);